import React from 'react'
import Filling from '../Images/Filling.png'

function PopularGuide() {
    return (
        <>
            <h1 style={{ textAlign: "center", fontSize: "1.8rem", color: 'black',fontFamily:"poppins" }}><b>Income Tax e-filing Popular Guides</b></h1>




            <div class="container">
                <div class="row">
                    <div class="col">
                        <img src={Filling} style={{width:"610px",height:"335px"}}/>
                    </div>
                    <div class="col">
                        <div class="faq" id="accordion">
                            <div class="card">
                                <div class="card-header" id="faqHeading-1">
                                    <div class="mb-0">
                                        <h5 class="faq-title" style={{fontFamily:"poppins",fontSize:"18px"}}  >
                                            <span class="badge"><i class="fas fa-arrow-right"></i></span>Income Tax Deductions
                                        </h5>
                                    </div>
                                </div>

                            </div>
                            <div class="card">
                                <div class="card-header" id="faqHeading-2">
                                    <div class="mb-0">
                                        <h5 class="faq-title" style={{fontFamily:"poppins",fontSize:"18px"}} >
                                            <span class="badge"><i class="fas fa-arrow-right"></i></span> Know the easiest way to link Aadhaar card with PAN card
                                        </h5>
                                    </div>
                                </div>

                            </div>
                            <div class="card">
                                <div class="card-header" id="faqHeading-3">
                                    <div class="mb-0">
                                        <h5 class="faq-title" style={{fontFamily:"poppins",fontSize:"18px"}}  >
                                            <span class="badge"><i class="fas fa-arrow-right"></i></span>Income Tax Slabs and Rates for FY 2022-23
                                        </h5>
                                    </div>
                                </div>

                            </div>
                            <div class="card">
                                <div class="card-header" id="faqHeading-4">
                                    <div class="mb-0">
                                        <h5 class="faq-title" style={{fontFamily:"poppins",fontSize:"18px"}} >
                                            <span class="badge"><i class="fas fa-arrow-right"></i></span> How to E-verify Income Tax Return for FY 2022-23
                                        </h5>
                                    </div>
                                </div>

                            </div>
                            <div class="card">
                                <div class="card-header" id="faqHeading-5">
                                    <div class="mb-0">
                                        <h5 class="faq-title" style={{fontFamily:"poppins",fontSize:"18px"}} >
                                            <span class="badge"><i class="fas fa-arrow-right"></i></span> Complete Guide on Rent Slips/Receipts and Claim HRA Tax
                                        </h5>
                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default PopularGuide